export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600">欢迎漫画作者投稿合作，或通过以下方式与我们取得联系</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-3">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">submit@51manhua.com</p>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-3">
                <i className="ri-customer-service-2-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">读者反馈</h3>
              <p className="text-xs text-foreground-500">feedback@51manhua.com</p>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-xl mx-auto mb-3">
                <i className="ri-group-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@51manhua.com</p>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-background-200/70 text-center">
            <p className="text-xs text-foreground-500">
              漫画家投稿请附上作品样张与个人简介，我们会在3个工作日内回复评估结果。
              51漫画在线欢迎每一位有才华的创作者加入。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}